import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

let routerView = () => import("@/components/routerView");

let repairRoom = () => import("@/components/repairRoom");
let repairSchool = () => import("@/components/repairSchool");
let repairManage = () => import("@/components/repairManage");
let myRepair = () => import("@/components/myRepair");
let apply = () => import("@/components/apply");
let applyManage = () => import("@/components/applyManage");
let repair = () => import("@/components/repair");
let error = () => import("@/components/error");
let cname = () => import("@/components/cname");

let router = new Router({
    mode: "history",
    routes: [
        {
            path: "/wxpage/manage",
            component: routerView,
            children: [
                {
                    path: "repair",
                    component: repairManage,
                    meta: {
                        title: "空调报修管理"
                    }
                },
                {
                    path: "apply",
                    component: applyManage,
                    meta: {
                        title: "空调申请管理"
                    }
                }
            ]
        },
        {
            path: "/wxpage/user",
            component: routerView,
            children: [
                {
                    path: "myrepair",
                    component: myRepair,
                    meta: {
                        title: "我的报修记录"
                    }
                },
                {
                    path: "cname",
                    component: cname,
                    meta: {
                        title: "填写姓名"
                    }
                }
            ]
        },
        {
            path: "/wxpage/:school",
            component: routerView,
            children: [
                {
                    path: "repair",
                    component: repair,
                    meta: {
                        title: "空调报修"
                    }
                },
                {
                    path: "repair/room",
                    component: repairRoom,
                    meta: {
                        title: "寝室报修申请"
                    }
                },
                {
                    path: "repair/school",
                    component: repairSchool,
                    meta: {
                        title: "单位报修申请"
                    }
                },
                {
                    path: "apply",
                    component: apply,
                    meta: {
                        title: "空调租赁申请"
                    }
                }
            ]
        },
        {
            path: "/wxpage/error",
            component: routerView,
            children: [
                {
                    path: "error",
                    component: error,
                    meta: {
                        title: "错误"
                    }
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "虹艺空调";
    next();
});

export default router;
